import React from 'react';
import ReactDOM from 'react-dom';

const Modal = ({ isOpen, onClose, children, header }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 modelIndex flex items-center justify-center bg-black bg-opacity-50 px-4 py-6">
      <div className={`relative cardBackgroundColor rounded-xl shadow-md p-4 max-w-full max-h-screen overflow-auto top-2 bottom-2 right-2 left-2 modal-popup-width`}>
        <div className="flex gap-2 items-center justify-between">
          <p className="font-semibold blackColor">{header}</p>
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-black text-xl font-bold"
          >&times;
          </button>
        </div>
        {children}
      </div>
    </div>,
    document.body
  );
};

export default Modal;
